import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/shared/guards/auth.guard";
import { UmovmeEnvironmentDetailsComponent } from "./components/umovme-environment-details/umovme-environment-details.component";
import { UmovmeEnvironmentComponent } from "./components/umovme-environment.component";

const routes: Routes = [
  {
    path: "umovme-environment/list",
    component: UmovmeEnvironmentComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Ambientes Umov.me",
    },
  },
  {
    path: "umovme-environment/details",
    component: UmovmeEnvironmentDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: "Cadastro/Edição Ambiente Umov.me",
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UmovmeEnvironmentRoutingModule {}
